export default "/images/ddd21753cb71813b201e9041c7033a53.avif";